import { render, staticRenderFns } from "./VisuallyHidden.vue?vue&type=template&id=70ef0304&scoped=true"
import script from "./VisuallyHidden.vue?vue&type=script&lang=js"
export * from "./VisuallyHidden.vue?vue&type=script&lang=js"
import style0 from "./VisuallyHidden.vue?vue&type=style&index=0&id=70ef0304&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ef0304",
  null
  
)

export default component.exports